import { UseQueryResult } from 'react-query';
import { Snackbar } from '../pure/snackbar/snackbar.component';

export function FileDownloader<
  P extends Array<unknown>,
  T extends (onSuccess: (response: string) => void, ...args: P) => UseQueryResult<string>
>({
  useFile,
  args,
  generateFilename,
  onDone
}: {
  useFile: T;
  args: [...P];
  generateFilename(): string;
  onDone(): void;
}) {
  const result = useFile((file) => {
    const blob = new Blob([file], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = generateFilename();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    onDone();
  }, ...args);

  if (result.error) {
    return (
      <Snackbar onClose={() => onDone()} severity="error">
        Sorry, there was a problem fetching your download
      </Snackbar>
    );
  }

  return null;
}
